module.exports = __webpack_public_path__ + "d632750a584980ac9fa360df7ceb5d25.svg";